import useRouter from '@gef-ui/router-core/hooks/useRouter';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '@gef-ui/components/atoms/Button/Button';
import Text, { typeConstants, weightConstants } from '@gef-ui/components/atoms/Text/Text';
import { Grid, GridCol } from '@gef-ui/components/organisms/Grid';
import { getLabelMessage, getMessage } from '@gef-ui/localization/messages';
import CopyToClipboard from '@gef-ui/features/copyToClipboard';
import { revokeComingFromUrl, revokeDelegationCookies, revokeOriginalUserCookies } from '../../utils';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'Error';
const Error = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const location = useRouter().useLocation();
    const { Wrapper = React.Fragment, toastrConfig } = props;
    const { error, showButton = true } = location.state;
    const handleReload = ()=>()=>{
            revokeDelegationCookies();
            revokeOriginalUserCookies();
            revokeComingFromUrl();
            window.location.href = '/';
        };
    const errorDetail = JSON.stringify(error, null, 2);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Delegations"
    }, /*#__PURE__*/ React.createElement(Wrapper, {}, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "Delegations-error Text--mainTitle",
        elementParagraph: true,
        type: typeConstants.PRIMARY,
        weight: weightConstants.MEDIUM
    }, getMessage('common:configuratorError')), showButton && /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 4
    }), /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 4
    }, /*#__PURE__*/ React.createElement(Button, {
        primary: true,
        block: true,
        label: getMessage('common:update'),
        onClick: handleReload()
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "Delegations-divider"
    }, getLabelMessage('common:errorDetailLabel')), /*#__PURE__*/ React.createElement("div", {
        className: "Text-center"
    }, /*#__PURE__*/ React.createElement("b", null, getMessage('common:instructionLabel')), /*#__PURE__*/ React.createElement(CopyToClipboard, {
        className: "Space--noSides",
        clipboardValue: errorDetail,
        toasrtConfig: toastrConfig
    })), /*#__PURE__*/ React.createElement("pre", null, errorDetail))));
};
Error.propTypes = {
    Wrapper: PropTypes.any,
    location: PropTypes.shape({
        state: PropTypes.shape({
            error: PropTypes.any,
            showButton: PropTypes.bool
        })
    }),
    toastrConfig: PropTypes.object
};
export default Error;
